import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Autocomplete } from '@material-ui/lab'
import getAdditionalEmployee from '../api/getAdditionalEmployee'
import Tooltip from '../../components/Tooltip/Tooltip'
import TooltipContent from './TooltipContent'
import Avatar from '@components/Avatar'
import EmployeeInitials from '@components/EmployeeInitials'
import Trash from '../../components/Icon/Trash'
import { actions } from '../listView.reducer'
import { massProcessingApi } from '@atheneum/api'
import { TextField, InputAdornment } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'

const share = async (
  dispatch,
  { id, userId, email, fullName, picture, currentPosition, firstName, lastName }
) => {
  dispatch({
    type: actions.ADD_EMPLOYEE,
    payload: {
      userId,
      email,
      fullName,
      picture,
      currentPosition,
      firstName,
      lastName
    }
  })
  await massProcessingApi.shareList({
    id,
    userId,
    email,
    fullName,
    picture,
    currentPosition,
    firstName,
    lastName
  })
}

const ShareWithEmployeesModel = ({
  dispatch,
  state,
  value,
  inputValue,
  setInputValue,
  hoverEmployee,
  handleHoverEmployee
}) => {
  const removeEmployee = ({ id, userId }) => {
    dispatch({ type: actions.REMOVE_EMPLOYEE, payload: userId })
    massProcessingApi.deleteShare({ id, userId })
  }

  const [allEmployees, setAllEmployeesTest] = useState([])

  useEffect(() => {
    axios({
      method: 'get',
      url: '/api/employee/list-all',
      headers: {
        authorization: localStorage.getItem('ngStorage-accessToken')
      }
    }).then(res => {
      const activeEmployees = res.data.filter(employee => employee.active)
      setAllEmployeesTest(activeEmployees)
    })
  }, [])

  return (
    <div className="mass-processing-list-shareModel">
      <div className="mass-processing-list-shareModel_searchContainer">
        <h4>Share the list</h4>
        <Autocomplete
          value={value}
          onChange={(_event, newValue) => {
            setInputValue('')
            getAdditionalEmployee(newValue.id).then(({ data }) => {
              share(dispatch, {
                id: state.list.id,
                userId: data.id,
                email: data.email,
                fullName: data.fullName,
                picture: !!data.picture?.path ? data.picture.path : '',
                currentPosition: data.currentPosition,
                firstName: data.firstName,
                lastName: data.lastName
              })
            })
          }}
          inputValue={inputValue}
          onInputChange={(_event, newInputValue) => {
            setInputValue(newInputValue)
          }}
          options={allEmployees.filter(
            employee =>
              !state.list.sharedWith
                .map(employee => employee.userId)
                .includes(employee.id) && employee.id !== state.list.owner
          )}
          getOptionLabel={option => option.name}
          style={{ width: 300 }}
          renderInput={params => {
            return (
              <>
                <TextField
                  {...params}
                  placeholder="Search"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: '#9d9d9d' }} />
                        </InputAdornment>
                        {params.InputProps.startAdornment}
                      </>
                    )
                  }}
                />
              </>
            )
          }}
        />
      </div>
      <div className="involvedEmployees-optionContainer">
        {state.list.sharedWith.map((employee, i) => {
          const havePicture = !!employee.picture.length
          return (
            <div
              key={i}
              className="mass-processing-list-employeeOption"
              onMouseOver={() => handleHoverEmployee(employee.userId)}
              onMouseLeave={() => handleHoverEmployee(0)}>
              <p>
                {havePicture ? (
                  <Tooltip
                    key={i}
                    tooltip={TooltipContent({
                      employeeData: employee
                    })}>
                    <div>
                      <Avatar
                        className="mass-processing-list-userAvatar mass-processing-list-userAvatarSmall"
                        alt="User avatar"
                        src={employee.picture}
                      />
                    </div>
                  </Tooltip>
                ) : (
                  <>
                    <EmployeeInitials
                      key={i}
                      employee={{ ...employee, id: employee.userId }}
                    />
                  </>
                )}
                <span style={{ marginLeft: '10px' }}>
                  {' '}
                  {employee.fullName}{' '}
                </span>
              </p>
              {hoverEmployee === employee.userId && (
                <button
                  className="mass-processing-list-smallTrash"
                  onClick={() =>
                    removeEmployee({
                      id: state.list.id,
                      userId: employee.userId
                    })
                  }>
                  <Trash />
                </button>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ShareWithEmployeesModel
